module.exports = __webpack_public_path__ + "assets/img/app.2bb65119.png";